import { render, staticRenderFns } from "./TechExpertRepairs.vue?vue&type=template&id=740f9a45&scoped=true"
import script from "./TechExpertRepairs.vue?vue&type=script&lang=js"
export * from "./TechExpertRepairs.vue?vue&type=script&lang=js"
import style0 from "./TechExpertRepairs.vue?vue&type=style&index=0&id=740f9a45&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f9a45",
  null
  
)

export default component.exports